import type { IconNode } from '../types';

/**
 * @name bed-bunk
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMiAyMlYyIiAvPgogIDxwYXRoIGQ9Ik0yIDVoMThhMiAyIDAgMCAxIDIgMnYxNSIgLz4KICA8cGF0aCBkPSJNNiA1djUiIC8+CiAgPHBhdGggZD0iTTIgMTBoMjAiIC8+CiAgPHBhdGggZD0iTTIgMTRoMjAiIC8+CiAgPHBhdGggZD0iTTIyIDE5SDIiIC8+CiAgPHBhdGggZD0iTTYgMTR2NSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/bed-bunk
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const bedBunk: IconNode = [
  ['path', { d: 'M2 22V2', key: '9hxi0x' }],
  ['path', { d: 'M2 5h18a2 2 0 0 1 2 2v15', key: 'yg6x0z' }],
  ['path', { d: 'M6 5v5', key: 'if1iwn' }],
  ['path', { d: 'M2 10h20', key: '1ir3d8' }],
  ['path', { d: 'M2 14h20', key: 'myj16y' }],
  ['path', { d: 'M22 19H2', key: 'nuriw5' }],
  ['path', { d: 'M6 14v5', key: '1mn3br' }],
];

export default bedBunk;
